export const statusOptions = [
  { value: 'offline', label: 'Offline' },
  { value: 'online', label: 'Online' },
  { value: 'unavailable', label: 'Unavailable' },
];
